<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="12" lg="10">
        <v-card dense :loading="loading">
          <v-toolbar color="light-green darken-1" dark flat>
            <v-toolbar-title>Speisekategorien</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-container class="pa-4" tile>
                <div v-if="!loading">
                  <v-card
                    class="pa-4 mb-4"
                    v-for="(category, index) in mealCategories"
                    :key="index"
                  >
                    <v-card-title>{{ category.name }}</v-card-title>
                    <v-row>
                      <v-col>
                        <v-combobox
                          :class="category.name"
                          multiple
                          small-chips
                          hide-no-data
                          deletable-chips
                          append-icon
                          label="Unterkategorien"
                          hint="Schreibe deine Kategorie und drücke Enter oder die Tabulator Taste"
                          persistent-hint
                          v-model="category.subcategories"
                        />
                      </v-col>
                    </v-row>
                  </v-card>
                </div>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              @click="save"
              color="success"
              name="submit"
              type="submit"
              :disabled="!formValid"
              >Speichern</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DataService from "@/services/DataService";

export default {
  name: "MailSettings",
  components: {},
  data: () => ({
    loading: false,
    mealCategories: [],
    vorspeisen: {
      subkategorien: [],
      color: "red",
      image: ""
    },
    hauptspeisen: {
      subkategorien: [],
      color: "green",
      image: ""
    },
    desserts: {
      subkategorien: [],
      color: "yellow",
      image: ""
    },

    requiredRule: [value => !!value || "Dieses Feld wird benötigt!"],
    emailRules: [
      v => !!v || "E-mail wird benötigt!",
      v =>
        /.+@.+/.test(v) ||
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,5})+$/.test(v) ||
        "E-mail muss ein gültiges Format haben"
    ],
    formValid: true
  }),
  methods: {
    save() {
      DataService.apiClient
        .patch("/meal/categories", {
          categories: this.mealCategories
        })
        .then(() => {
          this.$notify({
            group: "dataline",
            type: "success",
            title: "Einstellungen gespeichert",
            text: "Kategorien erfolgreich gespeichert"
          });
        })
        .catch(error => {
          this.$notify({
            group: "dataline",
            type: "error",
            title: "Fehler",
            text: error.message
          });
        });
    }
  },
  created() {
    this.loading = true;
    DataService.apiClient
      .get("/meal/categories")
      .then(result => {
        if (result.data) {
          this.mealCategories = result.data.data;
        }
      })
      .catch(error => {
        this.$notify({
          group: "dataline",
          type: "error",
          title: "Fehler",
          text: error.message
        });
      })
      .finally(() => {
        this.loading = false;
      });
  }
};
</script>

<style scoped>
.vorspeisen span.v-chip {
  background-color: red;
}
</style>
